<template>
  <MainViewFrame>
    <div class="courseView">
      
      <div class="items" v-if="data_type === 'my'">
        <div class="item four_item" v-for="(item, index) in my_data" :key="item.pk">
          <WorkItem :dic="item" :data-type="data_type" 
            @jumpToWorkDetail="jumpToWorkDetail" 
            @likeWorkEvent="likeWorkEvent"
            @sendToCompanyEvent="sendToCompanyEvent"
            @deleteWork="deleteWork"/>
        </div>
      </div>

      <div class="items" v-else-if="data_type === 'move'">
        <div class="item four_item" v-for="(item, index) in move_data" :key="item.pk">
          <WorkItem :dic="item" :data-type="data_type"
            @jumpToWorkDetail="jumpToWorkDetail" 
            @likeWorkEvent="likeWorkEvent"
            @sendToCompanyEvent="sendToCompanyEvent"
            @deleteWork="deleteWork"/>
        </div>
      </div>

      <div class="items" v-else-if="data_type === 'user_top'">
        <div class="item four_item" v-for="(item, index) in user_top_data" :key="item.pk">
          <WorkItem :dic="item" :data-type="data_type" 
            @jumpToWorkDetail="jumpToWorkDetail" 
            @likeWorkEvent="likeWorkEvent"
            @sendToCompanyEvent="sendToCompanyEvent"
            @deleteWork="deleteWork"/>
        </div>
      </div>
        
    </div>
  </MainViewFrame>
</template>

<script>
// @ is an alias to /src
import { Utils } from "@/utils";

import MainViewFrame from "../MainViewFrame.vue";
import WorkItem from "./components/WorkItem.vue";

import { types as WorkTypes } from "@/store/modules/work";
import { types as CompanyTypes } from "@/store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "Works",
  components: {
    MainViewFrame,
    WorkItem
  },
  data() {
    return {
      data_type: ""
    };
  },
  computed: {
    ...mapState({
      my_page: state => state.work.page,
      my_load_more: state => state.work.load_more,
      my_data: state => state.work.data,

      move_page: state => state.work.move_data.page,
      move_load_more: state => state.work.move_data.load_more,
      move_data: state => state.work.move_data.data,

      user_top_page: state => state.work.user_top_data.page,
      user_top_load_more: state => state.work.user_top_data.load_more,
      user_top_data: state => state.work.user_top_data.data,
    })
  },

  methods: {
    ...mapActions({
      fetchWorksData: WorkTypes.FETCH_LIST_MY_WORKS,
      fetchLikeWorkEvent: WorkTypes.FETCH_LIKE_EVENT,
      fetchDeleteWorkEvent: WorkTypes.FETCH_DELETE_WORK,
      fetchCreateProduct:CompanyTypes.FETCH_PRODUCT_CREATE,
    }),
    
    ...Utils,
    load_data(tag=""){
      let page = 1, 
          load_more = false;
      if(this.data_type === 'my'){
        // 我的作品
        page = this.my_page
        load_more = this.my_load_more
      }else if(this.data_type === 'move'){
        // 国外搬运
        page = this.move_page
        load_more = this.move_load_more
      } else if(this.data_type === 'user_top'){
        // 学员精选
        page = this.user_top_page
        load_more = this.user_top_load_more
      }

      if(tag === "next"){
        if(load_more){
          console.log("请求下一页数据")
          page += 1
        }else{
          console.log("无法请求下一页数据")
          return
        }
      }

      let dic = {
        page: page,
        data_type:this.data_type
      }

      if(this.data_type === 'my'){
        // 我的
        dic["user_id"] = this.user_id
        this.fetchWorksData(dic)
      } else if(this.data_type === "user_top"){
        // 学员精选
        dic["top"] = true
        dic["work_type"] = "scratch3"
        this.fetchWorksData(dic)
      } else if(this.data_type === 'move'){
        // 国外搬运
        dic["owner"] = "88820190449"
        dic["work_type"] = "scratch3"
        this.fetchWorksData(dic);
      }
    },
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }

      // console.log("作品列表:", height, scrollHeight, scrollTop);
      // console.log(height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        that.load_data("next")
      } else {
        console.log("没到底部");
      }
    },
    // --------------workItem 组件回调事件
    //点赞作品
    likeWorkEvent(item) {
      this.fetchLikeWorkEvent({pk:item.pk, data_type: this.data_type});
    },
    //作品详情页
    jumpToWorkDetail(item) {
      let host = location.host;
      if (location.host.indexOf("develop.cxy61.com") > -1) {
        host = "app.bcjiaoyu.com";
      }
      window.open(
        `https://${host}/html/works/works_detail.html?pk=${item.pk}`,
        "_blank"
      );
    },
    // 将作品放到公司产品中
    sendToCompanyEvent(item){
      this.fetchCreateProduct({"showwork_id":item.pk})
    },
    // 删除作品
    deleteWork(item){
      this.fetchDeleteWorkEvent({pk:item.pk, data_type: this.data_type});
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    let data_type = ""
    if (this.$route.query.tag) {
      data_type = this.$route.query.tag;
    } 
    this.data_type = data_type;

    if (this.$route.query.user) {
      this.user_id = this.$route.query.user;
    } 

    this.load_data();
  }
};
</script>

<style lang="less" scoped>
.courseView {
  background-color: #f8f8f8;
  border-radius: 4px;
  padding: 10px;
  min-height: 500px;

  .items {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px 0;
    margin-left: -10px;
    margin-bottom: 0;
    min-height: 120px;
    .item {
      width: calc(100% / 3 - 12px);
      margin-left: 10px;
      margin-bottom: 10px;
      border: solid 1px #ebebeb;
      cursor: pointer;
      background-color: #ffffff;
      border-radius: 4px;
      overflow: hidden;
      &.four_item{
        width: calc(100% / 4 - 12px);
      }
    }
  }
}
</style>
